module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_as-dba5722664b3ed3cc8c40eae677948eb.png";